import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { usePayment } from 'publisher/store'
import paymentSelectors from 'publisher/store/payment/paymentSelectors'
import React from 'react'
import BaseFieldNew from 'src/publisher/entities/field-new/base-field'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'

interface CompanyVatFieldProps {
  entity: FieldEntityInterface
}

const CompanyVatFieldNew = ({ entity }: CompanyVatFieldProps) => {
  const isPersonal = usePayment(paymentSelectors.isCustomerPersonal)

  if (typeof window === 'undefined') {
    return (
      <StyleWrapper
        margin={entity.margin}
        mobileMargin={entity.mobileMargin}
        appearance={entity.appearance}
      />
    )
  }

  return isPersonal ? <div /> : <BaseFieldNew entity={entity} />
}

export default CompanyVatFieldNew
